import { QStack, QTag } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

export type tagAction = 'removed' | 'added';

export const QTagList = ({
  tagNames,
  action,
}: {
  tagNames: string[];
  action: tagAction;
}) => {
  const { t } = useTranslation();
  return (
    <>
      {tagNames.length
        ? tagNames.map((tagName: string) => {
            return (
              <QStack pr={4} key={tagName}>
                {action === 'removed' && (
                  <QTag variantColor={'red'}>
                    {t('comments.tagRemoved')}
                    {tagName}
                  </QTag>
                )}
                {action === 'added' && (
                  <QTag variantColor={'green'}>
                    {t('comments.tagAdded')}
                    {tagName}
                  </QTag>
                )}
              </QStack>
            );
          })
        : null}
    </>
  );
};
